var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"shipping-info"},[_vm._m(0),_vm._v(" "),_c('span',[_vm._v("\n        "+_vm._s(_vm.shippingText)+"\n    ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"ico ico-shadow-truck"},[_c('i',{staticClass:"path1"}),_vm._v(" "),_c('i',{staticClass:"path2"})])
}]
render._withStripped = true
export { render, staticRenderFns }